import {allowedQueryParamFacets} from '../constants/common';

type QueryParams = Record<string, string | string[]>;

const containsEncodedComponents = (x: string) => {
  // ie ?,=,&,/ etc
  return decodeURI(x) !== decodeURIComponent(x);
};

export const convertFacetQueryToParams = (facetQuery: string): QueryParams => {
  const params = new Map();

  // reset previous params
  allowedQueryParamFacets.forEach((key) => {
    params.set(key, ``);
  });

  let previousKey = ``;

  facetQuery.split(`:`).forEach((facet, index) => {
    const isIndexKey = index % 2 === 0;

    if (isIndexKey) {
      const isKeyAllowed = allowedQueryParamFacets.includes(facet);
      previousKey = facet;

      if (!isKeyAllowed) return;
      if (!params.get(facet)) params.set(facet, []);
      previousKey = facet;
    } else {
      if (!allowedQueryParamFacets.includes(previousKey)) return;
      const f2 = containsEncodedComponents(facet)
        ? decodeURIComponent(facet)
        : facet;
      if (!f2) return;
      const value = [...params.get(previousKey), f2];
      params.set(previousKey, value);
    }
  });

  return Object.fromEntries(params);
};

export const convertParamsToQuery = (params: URLSearchParams): string => {
  const querySet = new Set();

  for (const [key, value] of params.entries()) {
    if (allowedQueryParamFacets.includes(key)) {
      querySet.add(`${key}:${value}`);
    }
  }

  return Array.from(querySet.values()).join(`:`);
};
